<template>
  <v-content fill-height class="contact page">
    <v-container class="mt-2 text-xs-center">
      <v-layout row wrap>
        <v-flex xs12 sm12 md12>
          <h1>Contact Me</h1>
        </v-flex>
      </v-layout>
    </v-container>
    <v-container>
      <v-layout row wrap>
        <v-flex xs12 sm12 md8>
          <v-snackbar v-model="snackbar" absolute top right color="success">
            <span>Thank you for your message!</span>
            <v-icon dark>check_circle</v-icon>
          </v-snackbar>
          <Loading  v-if="loading"/>
          <v-form ref="form" @submit.prevent="submit" class="white mx-2" v-if="loading==false">
            <v-container grid-list-xl fluid>
              <v-layout wrap>
                <v-flex xs12 sm12 md12 class="text-xs-center">
                  <h1>Send Mesage</h1>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="form.name"
                    :rules="rules.name"
                    color="purple darken-2"
                    label="Name"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="form.email"
                    :rules="rules.email"
                    color="blue darken-2"
                    label="Email"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-textarea v-model="form.message" color="teal">
                    <div slot="label">Message</div>
                  </v-textarea>
                </v-flex>
              </v-layout>
            </v-container>
            <v-card-actions>
              <v-btn flat @click="resetForm">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn :disabled="!formIsValid" flat color="primary" type="submit">Send Message</v-btn>
            </v-card-actions>
          </v-form>
        </v-flex>
        <v-flex sm12 md4 class="white px-4">
          <h2>Phone :</h2>
          <p>
            <a href="https://wa.me/6282359351889?text=Hai%20Wicak" target="_blank">
              <v-icon dark color="green" medium>fab fa-whatsapp-square</v-icon>
            </a>
            <span class="ml-2">+6282359351889</span>
          </p>
          <h2>Email :</h2>
          <p>
            <v-icon dark color="green" medium @click="sendMessage()">fas fa-envelope</v-icon>
            <span class="ml-2">wicaker.email@gmail.com</span>
          </p>
          <div class="mt-2">
            <a :href="'https://www.linkedin.com/in/i-gede-wicaksana-761a69152/'" target="_blank">
              <v-icon medium color="blue" class="mx-1">fab fa-linkedin</v-icon>
            </a>
            <a :href="'https://twitter.com/igedewicaksana'" target="_blank">
              <v-icon medium color="blue" class="mx-1">fab fa-twitter</v-icon>
            </a>
            <a :href="'https://www.facebook.com/agus.wicaksana.9'" target="_blank">
              <v-icon medium color="blue" class="mx-1">fab fa-facebook</v-icon>
            </a>
            <a :href="'https://www.instagram.com/agus_wicaksana/'" target="_blank">
              <v-icon medium color="blue" class="mx-1">fab fa-instagram</v-icon>
            </a>
            <a :href="'https://github.com/wicaker'" target="_blank">
              <v-icon medium color="blue" class="mx-1">fab fa-github</v-icon>
            </a>
            <a :href="'https://stackoverflow.com/users/10874122/wicak'" target="_blank">
              <v-icon medium color="blue" class="mx-1">fab fa-stack-overflow</v-icon>
            </a>
          </div>
        </v-flex>
      </v-layout>
    </v-container>
  </v-content>
</template>

<script>
import axios from 'axios';
import Loading from "../components/Loading";
export default {
  components: { Loading },
  data() {
    const defaultForm = Object.freeze({
      name: "",
      email: "",
      message: ""
    });

    return {
      form: Object.assign({}, defaultForm),
      rules: {
        name: [val => (val || "").length > 0 || "Name is required"],
        email: [
          v => !!v || "Email is required",
          v => /.+@.+\..+/.test(v) || "Invalid email format"
        ]
      },
      snackbar: false,
      defaultForm,
      loading: false
    };
  },

  computed: {
    formIsValid() {
      return this.form.name && this.form.email;
    }
  },

  methods: {
    resetForm() {
      this.form = Object.assign({}, this.defaultForm);
      this.$refs.form.reset();
    },
    submit() {
      this.loading = true;
      axios.post("https://wicaker.herokuapp.com/api/v1/message", this.form)
        .then( async () => {
          this.loading = await false;
          this.snackbar = await true;
          return this.resetForm();
        })
        .catch(err =>{
          this.loading = false;
          window.confirm(err);
          console.log(err)
        });
    },
    sendMessage() {
      window.open(
        "https://mail.google.com/mail/?view=cm&fs=1&to=wicaker.email@gmail.com&su=Message&body=Hai Wicak"
      );
    }
  }
};
</script>
